module.exports = __webpack_public_path__ + "static/casa-vogue-0b0da2c218a012fba4fae6cc4a97f27f.png";